import { render } from "./FloatingAddButton.vue?vue&type=template&id=146fb3a2&scoped=true"
import script from "./FloatingAddButton.vue?vue&type=script&lang=js"
export * from "./FloatingAddButton.vue?vue&type=script&lang=js"

import "./FloatingAddButton.vue?vue&type=style&index=0&id=146fb3a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146fb3a2"]])

export default __exports__